var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvtar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3424 37.0699C35.1437 37.0415 34.8882 37.0415 34.6611 37.0699C29.6653 36.8993 25.6914 32.8056 25.6914 27.7738C25.6914 22.6282 29.8356 18.4492 35.0018 18.4492C40.1395 18.4492 44.3121 22.6282 44.3121 27.7738C44.2837 32.8056 40.3382 36.8993 35.3424 37.0699Z",
    stroke: "#613ED2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6541 56.1216C49.4633 61.0017 42.581 63.9657 34.9989 63.9657C27.4168 63.9657 20.5346 61.0017 15.3438 56.1216C15.6354 53.3073 17.3851 50.5529 20.5054 48.3973C28.4958 42.9483 41.5604 42.9483 49.4924 48.3973C52.6128 50.5529 54.3625 53.3073 54.6541 56.1216Z",
    stroke: "#613ED2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0007 63.9662C50.9979 63.9662 63.9662 50.9979 63.9662 35.0007C63.9662 19.0035 50.9979 6.03516 35.0007 6.03516C19.0035 6.03516 6.03516 19.0035 6.03516 35.0007C6.03516 50.9979 19.0035 63.9662 35.0007 63.9662Z",
    stroke: "#613ED2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvtar);
export default __webpack_public_path__ + "static/media/userAvtar.0acc71f6679b7755d3b2e538027740f5.svg";
export { ForwardRef as ReactComponent };